module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySignet@2x.2f4b68b.webp";